import { useEffect, useMemo, useState } from 'react'
import Particles from '@tsparticles/react'
import { type ISourceOptions } from '@tsparticles/engine'
import { ensureParticlesEngine } from '../particles/engine'
import { useEffects } from '../contexts/EffectsContext'

const DataFlowAnimation = () => {
	const [init, setInit] = useState(false)
	const { effects } = useEffects()

	useEffect(() => {
		ensureParticlesEngine().then(() => {
			setInit(true)
		})
	}, [])

	const options: ISourceOptions = useMemo(
		() => ({
			fpsLimit: 60,
			background: {
				color: 'transparent'
			},
			particles: {
				number: {
					value: 0, // Emitters control the particle count
				},
				color: {
					value: ['#ffc700', '#ff7f50', '#9acd32', '#61dafb', '#f9a', '#a9f']
				},
				shape: {
					type: ['circle', 'square', 'triangle', 'star'],
				},
				opacity: {
					value: 1,
				},
				size: {
					value: { min: 2, max: 4 }
				},
				move: {
					enable: true,
					speed: { min: 2, max: 4 },
					outModes: { default: 'destroy' },
				}
			},
			emitters: [
				{
					// Emitter for Left-to-Right flow
					position: { x: 20, y: 50 },
					rate: {
						quantity: 1,
						delay: 0.5
					},
					particles: {
						move: {
							path: {
								enable: true,
								delay: { value: 0 },
								generator: 'svgPathGenerator',
								options: {
									selectors: '#path1',
								}
							}
						}
					}
				},
				{
					// Emitter for Right-to-Left flow
					position: { x: 80, y: 50 },
					rate: {
						quantity: 1,
						delay: 0.5
					},
					particles: {
						move: {
							path: {
								enable: true,
								delay: { value: 0 },
								generator: 'svgPathGenerator',
								options: {
									selectors: '#path2',
								}
							}
						}
					}
				}
			]
		}),
		[],
	)

	// Effect disabled: collapse to nothing (no render loop, no canvas).
	if (!effects.dataFlow || !init) {
		return <></>
	}

	return (
		<div style={{ position: 'relative', width: '100%', height: '100px' }}>
			<svg width="0" height="0" style={{ position: 'absolute' }}>
				<defs>
					<path id="path1" d="M 20,50 C 40,20 60,80 80,50" />
					<path id="path2" d="M 80,50 C 60,20 40,80 20,50" />
				</defs>
			</svg>
			<Particles
				id="tsparticles-flow"
				options={options}
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					zIndex: 1
				}}
			/>
		</div>
	)
}

export default DataFlowAnimation
